<template>
  <div>
    <b-overlay
      id="overlay-background"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-table
        :fields="fields"
        :items="rows"
        hover
        responsive
        striped
        show-empty
      >
        <template #cell(change_type)="data">
          <div class="font-weight-bold">
            {{ data.value ? formatChangeType(data.value) : '---' }}
          </div>
        </template>
        <template #cell(previous_data)="data">
          <div
            v-if="data.item.previous_data"
            class="changes-container"
          >
            <div class="change-details previous-data">
              <div
                v-for="(value, key) in data.item.previous_data"
                :key="`prev-${key}`"
                class="font-weight-bold"
              >
                <span>{{ formatFieldValue(key, value) }}</span>
              </div>
            </div>
          </div>
          <div
            v-else
            class="text-muted"
          >
            No previous data
          </div>
        </template>
        <template #cell(new_data)="data">
          <div
            v-if="data.item.new_data"
            class="changes-container"
          >
            <div class="change-details new-data">
              <div
                v-for="(value, key) in data.item.new_data"
                :key="`new-${key}`"
                class="font-weight-bold"
              >
                <span>{{ formatFieldValue(key, value) }}</span>
              </div>
            </div>
          </div>
          <div
            v-else
            class="text-muted"
          >
            No new data
          </div>
        </template>
        <template #cell(date_time)="data">
          <div class="font-weight-bold">
            {{ data.value ? __dateTimeFormatter(data.value) : '---' }}
          </div>
        </template>
        <template #cell(edited_by)="data">
          <div class="font-weight-bold">
            {{ data.value.name || '---' }}
          </div>
        </template>
        <template #cell(status_at_change)="data">
          <div>
            <order-status-badge :status-key="data.value" />
          </div>
        </template>
      </b-table>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay,
  BTable,
} from 'bootstrap-vue'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BTable,
    BOverlay,
    OrderStatusBadge,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    edit_log_data: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      avatarText,
      sort: '',
      id: '',
      fields: [
        {
          key: 'change_type',
          label: 'Change Type',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'previous_data',
          label: 'Previous Data',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'new_data',
          label: 'New Data',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'status_at_change',
          label: 'Status',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'date_time',
          label: 'Date & Time',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'edited_by',
          label: 'Edited By',
          sortable: false,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
      ],
    }
  },
  computed: {
    rows() {
      if (!this.edit_log_data) return []
      if (Array.isArray(this.edit_log_data)) {
        return this.edit_log_data
      }
      if (this.edit_log_data.data && Array.isArray(this.edit_log_data.data)) {
        return this.edit_log_data.data
      }
      return []
    },
  },
  watch: {
    edit_log_data: {
      immediate: true,
      deep: true,
    },
  },
  methods: {
    formatChangeType(changeType) {
      return changeType.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },
    formatFieldName(fieldName) {
      return fieldName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    },
    formatFieldValue(key, value) {
      if (value === null || value === undefined) {
        return '---'
      }

      // Handle phone numbers
      if (key.includes('phone')) {
        return value
      }

      // Handle other fields
      return String(value)
    },
  },
}
</script>

<style scoped>
.changes-container {
  max-width: 300px;
}

.change-details {
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 8px;
}

h6 {
  font-size: 0.875rem;
  font-weight: 600;
}
</style>
